import * as ClassificationActions from '../actions/classification.actions';
import * as ObstacleActions from '../actions/obstacles.actions';
import { startCase } from 'lodash';

export type Action = ClassificationActions.All | ObstacleActions.All;

export interface ClassificationState {
    answered: boolean;
    data: number[];
    labels: string[];
    loading: boolean;
}

const defaultState: ClassificationState = {
    answered: false,
    data: [],
    labels: [],
    loading: false
};

const barrierExtension = {
    'full': 'Yes',
    'partial': 'No'
};

export const classificationReducer = (state: ClassificationState = defaultState, action: Action): ClassificationState => {
    switch (action.type) {

        case ClassificationActions.TYPE:
        case ClassificationActions.WIDTH:
        case ClassificationActions.FISH: {
            return {
                answered: true,
                data: [],
                labels: [],
                loading: true
            };
        }

        case ClassificationActions.TYPE_RESULTS:
        case ClassificationActions.FISH_RESULTS: {
            return {
                answered: true,
                data: action.data,
                labels: action.labels.map(label => startCase(label)),
                loading: false
            };
        }

        case ClassificationActions.WIDTH_RESULTS: {
            return {
                answered: true,
                data: action.data,
                labels: action.labels.map(label => barrierExtension[label]),
                loading: false
            };
        }

        case ObstacleActions.NEXT_OBSTACLE: {
            return {
                answered: false,
                data: [],
                labels: [],
                loading: false
            };
        }

        default: {
            return state;
        }
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/reducers/classification.reducer.ts